import { Injectable, inject } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../components/modal';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly ngbModal = inject(NgbModal);

  public open(content: any, options?: NgbModalOptions & { template?: any; props?: Record<string, any> }) {
    const { props, template, ...modalOptions } = options;

    const modalRef = this.ngbModal.open(template ?? ModalComponent, modalOptions);

    modalRef.componentInstance.content = content;
    if (props) {
      for (const [name, value] of Object.entries(props)) {
        modalRef.componentInstance[name] = value;
      }
    }

    return modalRef;
  }

  public close() {
    this.ngbModal.dismissAll();
  }
}
